import { window } from '../window.js';
import { HTMLControl } from './html_control.js';

const kTitleText = 'Close';

/**
 * Close button used on images.
 */
class ImageCloseButton extends HTMLControl {
  initialize() {
    super.initialize();
    if (!this.hasAttribute('title')) {
      this.setAttribute('title', kTitleText);
    }
  }

  static get markup() {
    return `
      <svg viewBox='0 0 24 24'>
        <polygon points='17.8,16.7 16.6,17.9 12,13.3 7.4,17.9 6.2,16.7 10.8,12.1 6.2,7.5 7.4,6.3 12,11 16.6,6.4 17.8,7.6 13.2,12.2'></polygon>
      </svg>`;
  }
}

window.customElements.define('image-close-button', ImageCloseButton);

export { ImageCloseButton };
